import { Tooltip } from '@mantine/core'
import { Skeleton } from '@mantine/core'
import { Info } from 'lucide-react'

export interface VoEHeroStatCardProps {
  label: string
  value: string | number
  suffix?: string
  info?: string
  loading?: boolean
}

export const VoEHeroStatCard = ({
  label,
  value,
  suffix,
  info,
  loading = false,
}: VoEHeroStatCardProps) => {
  return (
    <div className="rounded-lg border border-gray-200 bg-white px-5 py-4">
      <div className="flex items-center gap-1.5">
        <p className="text-sm text-doubleNickel-gray-600">{label}</p>
        {info && (
          <Tooltip
            label={info}
            multiline
            w={240}
            withArrow
            position="top"
          >
            <Info size={13} className="cursor-help text-gray-400" />
          </Tooltip>
        )}
      </div>

      {loading ? (
        <Skeleton height={32} width={80} mt={4} />
      ) : (
        <p className="mt-1 text-2xl font-semibold text-doubleNickel-gray-800">
          {value}
          {suffix && (
            <span className="ml-1 text-base font-medium text-gray-400">
              {suffix}
            </span>
          )}
        </p>
      )}
    </div>
  )
}
